module.exports = __webpack_public_path__ + "media/parents/national-decision-day-5113bbb3.png";